import { render, staticRenderFns } from "./proxy-bar.vue?vue&type=template&id=46db75f5"
import script from "./proxy-bar.vue?vue&type=script&lang=js"
export * from "./proxy-bar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports